import axios from 'axios';

export default class WeatherAPI {
    constructor(options) {
        if (!this.client) {
            const opts = Object.assign({
                baseURL: process.env.VUE_APP_API_BASE_URL,
                params: {
                    units: 'si',
                    lang: 'de',
                },
            }, options);

            this.client = axios.create(opts);
        }
    }

    getForecast(lat, lng) {
        return this.client.get(`/forecast?lat=${lat}&lng=${lng}`);
    }
}
